import { showToast, TOKEN_KEYS } from "./Util";

export const preserveAuthTokens = () => {
  const tokens = {
    currentToken: localStorage.getItem(TOKEN_KEYS.JWT) || localStorage.getItem("token"),
    userBusinessType: localStorage.getItem(TOKEN_KEYS.BUSINESS_TYPE),
    userEntityType: localStorage.getItem(TOKEN_KEYS.ENTITY_TYPE),
    userInfo: localStorage.getItem(TOKEN_KEYS.USER_INFO),
    adminToken: localStorage.getItem("token"),
    webToken: localStorage.getItem("webToken"),
    sessionId: localStorage.getItem("sessionId"),
    timestamp: Date.now(),
  };

  window._preservedAuthTokens = tokens;
  return tokens;
};

export const restoreAuthTokens = (user) => {
  try {
    const preserved = window._preservedAuthTokens;
    if (!preserved) return;

    localStorage.removeItem(TOKEN_KEYS.SESSION_TIMEOUT);

    const setTokenIfNeeded = (key, value, fallbacks = []) => {
      if (!localStorage.getItem(key)) {
        const validValue = value || fallbacks.find((fb) => fb);
        if (validValue) localStorage.setItem(key, validValue);
      }
    };

    setTokenIfNeeded(TOKEN_KEYS.JWT, preserved.currentToken);
    setTokenIfNeeded("token", preserved.adminToken || preserved.currentToken);
    setTokenIfNeeded("webToken", preserved.webToken);
    setTokenIfNeeded("sessionId", preserved.sessionId);
    setTokenIfNeeded(TOKEN_KEYS.BUSINESS_TYPE, preserved.userBusinessType, [
      user?.user?.borrowerType,
      user?.user?.BorrowerType,
    ]);
    setTokenIfNeeded(TOKEN_KEYS.ENTITY_TYPE, preserved.userEntityType, [
      user?.user?.entityType,
      user?.user?.UserType,
    ]);
    setTokenIfNeeded(TOKEN_KEYS.USER_INFO, preserved.userInfo);
  } catch (error) {
    showToast.error("Error restoring tokens", error);
  }
};

export const ensureAuthTokens = (user) => {
  if (!user?.user?.jwtToken && !user?.jwtToken && !user?.token) return;

  const setTokenIfNeeded = (key, value) => {
    if (value && !localStorage.getItem(key)) {
      localStorage.setItem(key, value);
    }
  };

  setTokenIfNeeded(TOKEN_KEYS.JWT, user.user?.jwtToken || user?.jwtToken || user?.token);
  setTokenIfNeeded("token", user.user?.jwtToken || user?.jwtToken || user?.token);
  setTokenIfNeeded("webToken", user?.webToken);
  setTokenIfNeeded("sessionId", user?.sessionId);
  setTokenIfNeeded(
    TOKEN_KEYS.ENTITY_TYPE,
    user.user?.entityType || user.user?.UserType || user?.entityType || user?.UserType
  );
  setTokenIfNeeded(
    TOKEN_KEYS.BUSINESS_TYPE,
    user.user?.borrowerType || user.user?.BorrowerType || user?.borrowerType || user?.BorrowerType
  );
};


